import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  // Close panels & unlock scroll
  const closeAll = () => {
    setMenuOpen(false);
    setContactOpen(false);
    document.body.style.overflow = "";
  };

  // Lock/unlock scroll when a panel is open
  useEffect(() => {
    document.body.style.overflow = menuOpen || contactOpen ? "hidden" : "";
    return () => {
      // cleanup on unmount
      document.body.style.overflow = "";
    };
  }, [menuOpen, contactOpen]);

  // Auto-close on scroll
  useEffect(() => {
    window.addEventListener("scroll", closeAll);
    return () => window.removeEventListener("scroll", closeAll);
  }, []);

  return (
    <>
      <header className="header">
        <div className="header-content">
          {/* Logo */}
          <Link to="/" className="logo" onClick={closeAll}>
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="Mosike Electrical Contractors"
              loading="lazy"
              height="40"
            />
          </Link>

          {/* Nav (drawer on mobile) */}
          <nav className={`navbar ${menuOpen ? "active" : ""}`}>
            <button
              className="exit-btn"
              onClick={() => setMenuOpen(false)}
              aria-label="Close menu"
            >
              &times;
            </button>

            <Link to="/" onClick={closeAll}>home</Link>
            <Link to="/about" onClick={closeAll}>about</Link>

            <div className="dropdown">
              <span>Services</span>
              <div className="dropdown-content">
                <Link to="/services/electrical-wiring" onClick={closeAll}>Electrical Wiring</Link>
                <Link to="/services/lighting-installation" onClick={closeAll}>Lighting Installation</Link>
                <Link to="/services/circuit-design" onClick={closeAll}>Circuit Design</Link>
                <Link to="/services/power-backup-systems" onClick={closeAll}>Power Backup</Link>
                <Link to="/services/safety-inspection-compliance" onClick={closeAll}>Safety Inspection</Link>
                <Link to="/services/specialized-electrical-installations" onClick={closeAll}>
                  Specialized Electrical Installations
                </Link>
              </div>
            </div>

            <Link to="/products" onClick={closeAll}>products</Link>

            <div className="dropdown">
              <span>Projects</span>
              <div className="dropdown-content">
                <Link to="/projects/residential" onClick={closeAll}>Projects</Link>
              </div>
            </div>

            <Link to="/contact" onClick={closeAll}>contact</Link>
          </nav>

          {/* Icons */}
          <div className="icons">
            <button
              id="menu-btn"
              className="fas fa-bars"
              onClick={() => { closeAll(); setMenuOpen(v => !v); }}
              aria-label="Toggle menu"
              aria-expanded={menuOpen}
              aria-controls="primary-navigation"
            />
            <button
              id="info-btn"
              className="fas fa-info-circle"
              onClick={() => { closeAll(); setContactOpen(v => !v); }}
              aria-label="Contact info"
              aria-expanded={contactOpen}
            />
          </div>
        </div>
      </header>

      {/* Contact sidebar */}
      <aside className={`contact-info ${contactOpen ? "active" : ""}`}>
        <button
          id="close-contact-info"
          className="fas fa-times"
          onClick={() => setContactOpen(false)}
          aria-label="Close contact info"
        />
        <div className="info">
          <i className="fas fa-phone" /><h3>Cellphone</h3><p>(+27) 82 498 9477</p>
        </div>
        <div className="info">
          <i className="fas fa-envelope" /><h3>Email</h3><p>info@mosikeelectrical.com</p>
        </div>
        <div className="info">
          <i className="fas fa-map-marker-alt" /><h3>Head Office</h3>
          <p>59A Kirkness Road, The Orchards X10, 0182</p>
        </div>
        <div className="share">
          <a
            href="https://www.facebook.com/share/1DVgT2UucB/?mibextid=wwXIfr"
            className="fab fa-facebook-f"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            title="Facebook"
          >
            {/* icon-only link */}
          </a>
          <a
            href="https://www.instagram.com/mosikeelec_"
            className="fab fa-instagram"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            title="Instagram"
          >
            {/* icon-only link */}
          </a>
          <a
            href="https://www.linkedin.com/company/mosike-electrical-contractors/"
            className="fab fa-linkedin"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            title="LinkedIn"
          >
            {/* icon-only link */}
          </a>
        </div>
      </aside>

      {/* Overlay */}
      {(menuOpen || contactOpen) && <div className="overlay" onClick={closeAll} />}
    </>
  );
}
